<template>
  <div>
    <el-dialog title="Exchange Rates (Avg & Spot)" :visible.sync="dialogVisible" :close-on-click-modal="false" width="870px" top="5vh">
      <el-form :model="dataForm" :rules="dataFormRules" ref="formRef" label-position="right" class="pb20">
        <div class="flex jcsb">
          <div class="flex">
            <el-form-item prop="monthrange" class="mr10">
              <el-date-picker
                v-model="dataForm.monthrange"
                type="monthrange"
                range-separator="~"
                start-placeholder="Start month"
                end-placeholder="End month"
                value-format="yyyyMM"
                class="wd250"
              ></el-date-picker>
            </el-form-item>
            <el-form-item prop="baseCurrency" class="mr10">
              <el-select v-model="dataForm.baseCurrency" placeholder="Base Currency" clearable filterable class="wd200">
                <el-option v-for="item in exRateCurrencyExclusiveList" :key="item.currency" :label="item.currency" :value="item.currency"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="targetCurrency">
              <el-select v-model="dataForm.targetCurrency" placeholder="Target Currency" clearable filterable class="wd200">
                <el-option v-for="item in exRateCurrencyExclusiveList" :key="item.currency" :label="item.currency" :value="item.currency"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-button type="primary" :loading="submitLoading" @click="submitForm('dataForm')">Generate</el-button>
          </div>
        </div>
        <div class="contentHead">
          <p>
            Average exchange rate:
            <span class="ml6 black">{{ averageVal }}</span>
          </p>
          <p>
            Sport rate at the period end:
            <span class="ml6 black">{{ sportVal }}</span>
          </p>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { isNumberLike } from "@/utils";
import { addition, divide, fmoney } from "@/utils/count";
export default {
  props: {
    exRateCurrencyExclusiveList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      dataForm: {
        monthrange: [],
        baseCurrency: "",
        targetCurrency: "",
      },
      dataFormRules: {
        monthrange: [{ type: "array", required: true, message: "Please select", trigger: "submit" }],
        baseCurrency: [{ required: true, message: "Please select", trigger: "submit" }],
        targetCurrency: [{ required: true, message: "Please select", trigger: "submit" }],
      },
      averageVal: "",
      sportVal: "",
      submitLoading: false,
    };
  },
  methods: {
    // 初始化
    async init() {
      this.submitLoading = false;
      this.dialogVisible = true;
      this.averageVal = "";
      this.sportVal = "";
      await this.$nextTick();
      this.$refs.formRef.resetFields();
    },
    // 生成汇率
    submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          const monthrange = this.dataForm.monthrange;
          this.$http
            .get("/admin/exchangeRateByMonth", {
              params: {
                monthStart: monthrange[0],
                monthEnd: monthrange[1],
              },
            })
            .then(res => {
              const resData = res.data || [];
              // 按月份从小到大排序
              const sortedData = resData.sort((a, b) => Number(a.month) - Number(b.month));
              const rateArr = [];
              sortedData.forEach(item => {
                let baseExRateBasis = null;
                let baseExRateValue = null;
                let targetExRateBasis = null;
                let targetExRateValue = null;
                const detailList = item.detailList || [];
                // SGD 为基准货币，接口不返回其汇率，手动插入一条 1:1 的记录
                if (!detailList.some(ele => ele.currency === "SGD")) {
                  detailList.unshift({ currency: "SGD", exchangeRateBasis: "1", exchangeRateValue: "1" });
                }
                detailList.forEach(ele => {
                  if (ele.currency === this.dataForm.baseCurrency) {
                    baseExRateBasis = ele.exchangeRateBasis;
                    baseExRateValue = ele.exchangeRateValue;
                  }
                  if (ele.currency === this.dataForm.targetCurrency) {
                    targetExRateBasis = ele.exchangeRateBasis;
                    targetExRateValue = ele.exchangeRateValue;
                  }
                });
                if (isNumberLike(baseExRateBasis) && isNumberLike(baseExRateValue) && isNumberLike(targetExRateBasis) && isNumberLike(targetExRateValue)) {
                  // 获取基准货币的汇率值 = 保存的汇率 / 汇率基准金额
                  const baseRate = divide(baseExRateValue, baseExRateBasis);
                  const targetRate = divide(targetExRateValue, targetExRateBasis);
                  // 计算公式：基础货币汇率 / 目标货币汇率
                  const rate = divide(baseRate, targetRate);
                  rateArr.push(rate);
                }
              });
              this.getAverageRate(rateArr);
              this.getLastMonthRate(rateArr);
            })
            .catch(err => {
              console.error(err);
            })
            .finally(() => {
              this.submitLoading = false;
            });
        }
      });
    },
    // 获取所选月份平均汇率(将每月汇率相加后除以月份数)
    getAverageRate(rateArr) {
      const len = rateArr.length;
      if (len > 0) {
        const sum = addition(...rateArr);
        const average = divide(sum, len);
        this.averageVal = fmoney(average, 4);
      } else {
        this.averageVal = "N/A";
      }
    },
    // 获取所选月份最后一个月的汇率
    getLastMonthRate(rateArr) {
      const len = rateArr.length;
      if (len > 0) {
        const lastMonthRate = rateArr[len - 1];
        this.sportVal = fmoney(lastMonthRate, 4);
      } else {
        this.sportVal = "N/A";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contentHead {
  width: 100%;
  background: #f5f7fa;
  padding: 6px 16px;

  p {
    line-height: 18px;
    margin: 8px 0;
    font-size: 14px;
    color: #606266;
  }

  .black {
    font-size: 16px;
    color: #000000;
  }
}
</style>
